<div class="search-bar__search" wlKeyboardNavigation>
  <form class="search-bar__form" novalidate>
    <input
      #searchInput
      [(ngModel)]="searchQuery"
      aria-autocomplete="list"
      aria-label="Zoekbalk"
      autocapitalize="off"
      autocomplete="off"
      autocorrect="off"
      class="form-control search-bar__input"
      maxlength="99"
      name="search"
      placeholder="Zoeken naar..."
      spellcheck="false"
      type="search"
      wlAutomationId="search-bar"
    />
    <button
      (click)="submit($event)"
      aria-label="Zoekopdracht verzenden"
      class="btn btn-primary btn-search"
      type="submit"
    >
      <fa-icon class="fa-icon fa-xl" icon="search" />
    </button>
  </form>
  <wl-search-popover
    [class.search-bar__popover--visible]="elementHasFocus$ | async"
    [searchQuery]="searchQuery()"
    class="search-bar__popover"
  />
  @if (elementHasFocus$ | async) {
    <div wlDisableBodyScrolling minBreakpoint="md"></div>
  }
</div>
